














export default {
  name: 'Selectfield'
  props: [
    'id'
    'label'
    'value'
    'options'
  ]
  mounted: () ->
    componentHandler.upgradeElements @$el

  updated: () ->
    @$refs.select.MaterialSelectfield.checkDirty()

  beforeDestroy: ()->
      componentHandler.downgradeElements @$el

  methods:
    onInput: (event) ->
      @$emit 'input', event.target.value
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/Selectfield.vue